import Axios from "axios";
import { getCookie, isSem } from ".";
import qs from "querystring";

const serialize = function (obj) {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      if (![undefined, null, "", "undefined", "null"].includes(obj[p])) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    }
  return str.join("&");
};
export const connecttHuiju = async (form) => {
  const { data } = await Axios.get(
    "https://host.huiju.cool/formdata/get/602e8103b37e424883d2fb54696cfcaf",
    {
      headers: {
        Referer: "https://www.authing.cn",
        "content-type": "application/json",
      },
      timeout: 30000,
    }
  );
  let clInfo = {};
  //   clInfo.cltoken = data.token;
  clInfo.utma = getCookie("c__utma");
  clInfo.utmb = getCookie("c__utmb");
  clInfo.name = form.name;
  clInfo.mobile = form.phone;
  clInfo.company = form.company;
  clInfo.attr2 = form.utm_source || "SEO";
  clInfo.attr3 = form.utm_medium;
  clInfo.attr4 = form.utm_campaign;
  clInfo.attr5 = form.utm_term;
  clInfo.attr6 = form.other;
  clInfo.attr20 = typeof window !== "undefined" && window.location.hostname;

  try {
    const result = await Axios.post(
      `https://host.huiju.cool/form/602e8103b37e424883d2fb54696cfcaf?cltoken=${data.token}`,
      serialize(clInfo),
      {
        headers: {
          Referer: "https://www.authing.cn",
          "Content-Type": "application/x-www-form-urlencoded",
        },
        timeout: 30000,
      }
    );
    return result?.data;
  } catch (error) {
    console.log(error);
    return "error";
  }
};

export const phoneHuiju = async (phone) => {
  const { data } = await Axios.get(
    "https://host.huiju.cool/formdata/get/9e78020c2052433a8e371ddb93c2a03c",
    {
      headers: {
        Referer: "https://www.authing.cn",
        "content-type": "application/json",
      },
      timeout: 30000,
    }
  );
  let clInfo = {};
  //   clInfo.cltoken = data.token;
  clInfo.utma = getCookie("c__utma");
  clInfo.utmb = getCookie("c__utmb");

  clInfo.mobile = phone;
  clInfo.attr2 = isSem() ? "SEM" : "SEO";
  const result = await Axios.post(
    `https://host.huiju.cool/form/9e78020c2052433a8e371ddb93c2a03c?cltoken=${data.token}`,
    serialize(clInfo),
    // clInfo,
    {
      headers: {
        Referer: "https://www.authing.cn",
        "Content-Type": "application/x-www-form-urlencoded",
      },
      timeout: 30000,
    }
  );
};
